import Vue from "vue";

Vue.filter("formatDigit", val =>
  val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
);
